import React, {Component, Fragment} from 'react';
import {connect} from "react-redux";
import nophoto from "../../assets/img/nophoto.png";
import nophoto3 from "../../assets/img/bike.jpg";
import "../../assets/css/banner.css"
import {actionGetAllPropertyList, actionGetSuggestedLocations} from "../../actions/propertysAction";
import DataNotFound from "../layout/DataNotFound";
import PropertiesCard from "../common/Properties/propertiesCard";
import PropertyListCard from "../common/Properties/propertyListCard";
import defaultAgentAvatar from '../../assets/img/nophoto.png'
import '../../assets/css/custome-banner.css'
import PropertyListCardLoader from "../common/Properties/propertyListCardLoader";
import SuggestedLocationItem from "../common/SuggestedLocationItem";
import setAlert from "../../actions/setAlert";
import Navbar from "../common/navbar/Navbar";
import {HOME} from "../../actions/types";

class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            is_lastData: true,
            q: '',
            location: '',
            limit: 3,
            offset: 0,
            errors: {},
        }
    }

    componentDidMount() {
        document.title = "Home | Prime Private Network";
        // window.addEventListener('scroll', () => {
        //     let scrollHeight = document.documentElement.scrollHeight;
        //     let scrollTop = document.documentElement.scrollTop;
        //     let clientHeight = document.documentElement.clientHeight;
        //
        //     if ((scrollTop + clientHeight) > (scrollHeight - 300) && this.props.allProperties.length && !this.props.getAllPropertiesLoader && this.state.is_lastData) {
        //         this.setState({offset: this.state.offset + 1}, () =>  this.props.actionGetAllPropertyList({q:this.state.q,offset:this.state.offset,limit:this.state.limit,locations:this.state.location},this.setLastData));
        //     }
        // });
        this.setState({offset: 0});
        if (this.props.auth.user._id) {
            const request = {
                q: this.state.q,
                locations: this.state.location,
                offset: this.state.offset,
                limit: this.state.limit,
                category: '',
                user: '',
                type: "PUBLIC",
                status: "",
                bedRooms: "",
                bathRooms: "",
                furnishedStatus: "",
                transactionType: "",
                minPrice: "",
                maxPrice: ""
            };
            this.props.actionGetAllPropertyList(request, this.setLastData);

        }
    }

    componentDidUpdate(prevProps, nextState) {
        if (prevProps.auth.user._id !== this.props.auth.user._id) {
            const request = {
                q: this.state.q,
                locations: this.state.location,
                offset: this.state.offset,
                limit: this.state.limit,
                category: '',
                user: '',
                type: "public",
                status: "",
                bedRooms: "",
                bathRooms: "",
                furnishedStatus: "",
                transactionType: "",
                minPrice: "",
                maxPrice: ""
            };
            this.props.actionGetAllPropertyList(request, this.setLastData);
        }
    }

    setLastData = (status) => {
        this.setState({is_lastData: status})
    };

    onChange = (e) => this.setState({[e.target.name]: e.target.value}, () => {
        if (e.target.name === "q") {
            if (this.state.q.length < 1) {
                this.setState({offset: 0});
            }
        } else if (e.target.name === "location") {
            if (this.state.location.length < 1) {
                this.setState({offset: 0});
            }
        }

    });

    handleSearchValidation = () => {
        let fields = this.state;
        let errors = {};
        let formIsValid = true;
        if (!fields.q) {
            // formIsValid = false;
            // errors.q = "Please type something to search related data!";
        }
        this.setState({errors: errors});
        return formIsValid;
    };

    handleSearchSubmit = (e) => {
        e.preventDefault();
        if (this.handleSearchValidation()) {
            this.setState({offset: 0});
            const request = {
                q: this.state.q,
                locations: this.state.location,
                offset: this.state.offset,
                limit: this.state.limit,
                category: '',
                user: '',
                type: "PUBLIC",
                status: "",
                bedRooms: "",
                bathRooms: "",
                furnishedStatus: "",
                transactionType: "",
                minPrice: "",
                maxPrice: ""

            };
            this.props.actionGetAllPropertyList(request);

        }

    };
    onLocationInput = (e) => this.setState({[e.target.name]: e.target.value}, () => setTimeout(() => this.props.actionGetSuggestedLocations(this.state.location), 500));

    handleSearchResultArea = (value) => setTimeout(() => this.setState({searchInputFocused: value}), 250);

    handleSelectCurrentLocation = location => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                const lat = position.coords.latitude;
                const lng = position.coords.longitude;
                this.setState({lat, lng, location}, () => this.handleSearchResultArea(false));
            });
        } else setAlert('Geolocation is not supported by this browser.', 'error');
    };

    handleSelectLocation = (location, lat, lng) => this.setState({
        location,
        lat,
        lng
    }, () => this.handleSearchResultArea(false));

    render() {
        const {allProperties, getAllPropertiesLoader,suggestedLocations} = this.props;
        return (
            <Fragment>
                <Navbar scenario={HOME}/>
                <div className="home-page">
                <section className="banner_main">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="text-bg">
                                    <div className="padding_lert">
                                        <h1>WELCOME TO Prime Private Network </h1>

                                        <p>There are many variations of passages of Lorem Ipsum available, but the
                                            majority
                                            have
                                            suffered alteration in some form, by injected humour, or randomised words
                                            which
                                            don't look even slightly believable</p>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>


                <section>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <form className="form_book" autoComplete="off" onSubmit={this.handleSearchSubmit}>
                                    <div className="searchbox">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <input type="text" onChange={this.onChange} name="q" value={this.state.q} className="form-control" placeholder="Search by Agent Name and Title Name..."/>
                                            </div>
                                            <div className="col-md-4">
                                                <input type="text"
                                                       className="form-control"
                                                       name="location"
                                                       onChange={this.onLocationInput}
                                                       autoComplete={'off'}
                                                       value={this.state.location}
                                                       onFocus={() => this.handleSearchResultArea(true)}
                                                       onBlur={() => this.handleSearchResultArea(false)}
                                                       placeholder="Enter Location, Street, ZIP Code"/>

                                                {this.state.searchInputFocused &&
                                                <div className="suggestion-area">
                                                    <SuggestedLocationItem
                                                        key={0}
                                                        handleSelectLocation={this.handleSelectCurrentLocation}
                                                        formatted_address={''}
                                                        locationName={'Current Location'}/>
                                                    {suggestedLocations.map((location, index) =>
                                                        <SuggestedLocationItem
                                                            key={(index + 1)}
                                                            handleSelectLocation={this.handleSelectLocation}
                                                            lat={location.latitude}
                                                            lng={location.longitude}
                                                            locationName={location.name}
                                                            formatted_address={location.formatted_address}
                                                        />)}
                                                </div>}
                                            </div>
                                            <div className="col-md-1 m-auto">
                                                <button type="submit" className="btn btn-custom-1"> Search</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>

                <div className="properties-list-section">
                    <div className="container">
                        <div className="row justify-content-center mb-3">
                            <h1 className="h3 ">Featured Properties</h1>
                        </div>
                        <div className="flex">
                            {
                                allProperties && allProperties.map((property, index) =>
                                    <PropertyListCard
                                        index={index}
                                        id={property._id}
                                        subcategory_name={property.subcategory ? property.subcategory.name : ''}
                                        property_img={property.image}
                                        agent_avatart={property.user.avatar ? property.user.avatar : defaultAgentAvatar}
                                        property_price={property.price}
                                        property_title={property.title}
                                        property_bedroom={property.bedroom}
                                        property_city_name={property.city.name}
                                        property_country_name={property.country.name}
                                        property_carpet_area={property.carpet_area}
                                        property_super_area={property.super_area}
                                        property_list_date={property.list_date}
                                        property_owner_name={property.owner_name}
                                        likes={property.likes}
                                    />
                                )

                            }
                            {(!getAllPropertiesLoader && allProperties.length < 1) &&
                            <div className="text-center col-md-12"><DataNotFound
                                message={`Sorry! No any Property found.`}/></div>}

                            { (allProperties.length < 1 && getAllPropertiesLoader )&&
                            <Fragment>
                                <PropertyListCardLoader/>
                                <PropertyListCardLoader/>
                                <PropertyListCardLoader/>

                            </Fragment>}


                        </div>
                    </div>
                </div>
                </div>

            </Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    auth: state.auth,
    isAuthenticated: state.isAuthenticated,
    profile: state.profile,
    allProperties: state.property.allProperties,
    getAllPropertiesLoader: state.property.getAllPropertiesLoader,
    suggestedLocations: state.property.suggestedLocations,
});

export default connect(mapStateToProps, {actionGetAllPropertyList,actionGetSuggestedLocations})(
    Dashboard
);